import { cn } from '@/lib/cn';

export type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'live';

/** Soft fill, dark text, and a 1px edge a shade deeper than the fill. */
const toneStyles: Record<Tone, string> = {
  neutral:
    'bg-[color:var(--ts-pill-neutral-bg)] text-[color:var(--ts-pill-neutral-text)] border-[color:var(--ts-pill-neutral-border)]',
  info: 'bg-[color:var(--ts-pill-info-bg)] text-[color:var(--ts-pill-info-text)] border-[color:var(--ts-pill-info-border)]',
  success:
    'bg-[color:var(--ts-pill-success-bg)] text-[color:var(--ts-pill-success-text)] border-[color:var(--ts-pill-success-border)]',
  warning:
    'bg-[color:var(--ts-pill-warning-bg)] text-[color:var(--ts-pill-warning-text)] border-[color:var(--ts-pill-warning-border)]',
  danger:
    'bg-[color:var(--ts-pill-danger-bg)] text-[color:var(--ts-pill-danger-text)] border-[color:var(--ts-pill-danger-border)]',
  live: 'bg-[color:var(--ts-pill-warning-bg)] text-[color:var(--ts-pill-warning-text)] border-[color:var(--ts-pill-warning-border)]',
};

export interface PillProps {
  tone?: Tone;
  children: React.ReactNode;
  className?: string;
  title?: string;
}

export function Pill({ tone = 'neutral', children, className, title }: PillProps) {
  return (
    <span
      title={title}
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        toneStyles[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
